// Keeps one broken page from blanking the whole site. Keyed by route in
// App.js, so navigating away resets it.
import { Component } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Flex, Text } from "@chakra-ui/react";
import { MUTED } from "../theme";
import { Container, Display, Em, Mono } from "./ui";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Page crashed:", error, info.componentStack); // eslint-disable-line no-console
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Container>
        <Flex minH="60vh" direction="column" align="flex-start" justify="center" gap={5}>
          <Mono>Something tripped a breaker</Mono>
          <Display size="lg">
            This page <Em>crashed.</Em>
          </Display>
          <Text color={MUTED} maxW="480px">
            The rest of the site is fine — try reloading, or head back home.
          </Text>
          <Flex gap={3}>
            <Button variant="volt" onClick={() => window.location.reload()}>
              Reload
            </Button>
            <Button as={RouterLink} to="/" variant="line">
              Home
            </Button>
          </Flex>
        </Flex>
      </Container>
    );
  }
}

export default ErrorBoundary;
